<template>
  <div class="mall-bottom-bar">
    <div class="mall-bottom-bar__fade"></div>
    <div class="mall-bottom-bar__buttons">
      <MallButton
        v-for="button in buttons"
        :key="button.key"
        :label="button.label"
        :type="button.type"
        :disabled="button.disabled"
        :dimmed="button.dimmed"
        @click="$emit('click', button.key)"
      />
    </div>
  </div>
</template>

<script>
import MallButton from '@/components/new/atoms/MallButton.vue'

export default {
  name: 'MallBottomBar',
  components: {
    MallButton,
  },
  props: {
    // [{ key, label, type: 'primary' | 'secondary', disabled, dimmed(비활성 모양이지만 누를 수 있음) }]
    buttons: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.mall-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px;
  z-index: 10;
}

.mall-bottom-bar__fade {
  height: 20px;
  background: linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%);
}

.mall-bottom-bar__buttons {
  display: flex;
  padding: 0 16px 16px 16px;
  gap: 4px;
  background: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallBottomBar.vue